import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlanType } from '../../../models/quotation-model/catalogs/plan-type.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PlanTypeService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getPlanTypes(): Observable<PlanType[]> {
    return this.http.get<PlanType[]>(this.URL_API + '/PlanType');
  }
  getQuoterPlanTypes(): Observable<PlanType[]> {
    return this.http.get<PlanType[]>(this.URL_API + '/PlanType/GetQuoterPlanTypes');
  }
}
